import { forwardRef } from 'react';
// @mui
import { useTheme, alpha } from '@mui/material/styles';
import Link from '@mui/material/Link';
import Box, { BoxProps } from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
// routes
import { RouterLink } from 'src/routes/components';

// ----------------------------------------------------------------------

export interface LogoProps extends BoxProps {
  disabledLink?: boolean;
}

const Logo = forwardRef<HTMLDivElement, LogoProps>(
  ({ disabledLink = false, sx, ...other }, ref) => {
    const theme = useTheme();
    const isLight = theme.palette.mode === 'light';

    const logoContent = (
      <Stack
        direction="column"
        alignItems="flex-start"
        spacing={0}
        sx={{ 
          cursor: 'pointer',
          fontFamily: "'Inter', 'Roboto', sans-serif",
          ...sx
        }}
      >
        <Typography
          variant="caption"
          sx={{
            fontFamily: "'Outfit', 'Inter', sans-serif",
            fontWeight: 800,
            letterSpacing: '0.2em',
            textTransform: 'uppercase',
            color: 'text.secondary',
            opacity: 0.8,
            lineHeight: 1,
            ml: 0.5
          }}
        >
          STOREFRONT
        </Typography>
        <Typography
          variant="h5"
          sx={{
            fontFamily: "'Outfit', 'Inter', sans-serif",
            fontWeight: 900,
            letterSpacing: '0.15em',
            textTransform: 'uppercase',
            background: theme.palette.mode === 'dark'
              ? `linear-gradient(135deg, ${theme.palette.error.main} 0%, ${theme.palette.error.dark} 100%)`
              : `linear-gradient(135deg, ${theme.palette.error.dark} 0%, #000 100%)`,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            display: { xs: 'none', sm: 'block' },
            textShadow: theme.palette.mode === 'dark' ? `0 0 10px ${theme.palette.error.main}40` : 'none',
            lineHeight: 1
          }}
        >
          STALKER PRO
        </Typography>
      </Stack>
    );

    if (disabledLink) {
      return logoContent;
    }

    return (
      <Link
        component={RouterLink}
        href="/"
        sx={{
          display: 'inline-flex',
          textDecoration: 'none',
          '&:hover': {
            textDecoration: 'none',
          },
        }}
      >
        {logoContent}
      </Link>
    );
  }
);

export default Logo;
